import React from 'react'
import ListItem from '../presents/ListItem'

const ListItemTextContainer = ({
    textKey='text',
    itemType,
    itemData,
    additionalClass,
    isSelected,
    pathnameEdit,
    onDelete,
}) => {
    const text = itemData[textKey] ? itemData[textKey] : false

    return <ListItem
        title={text}
        styles={false}
        type={itemType}
        additionalClass={additionalClass}
        isSelected={isSelected}
        pathnameEdit={pathnameEdit}
        onDelete={onDelete}
    />
}

export default ListItemTextContainer